import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-password-compromised-modal',
  templateUrl: 'password-compromised-modal.html',
})

export class PasswordCompromisedModal{
    private activeModal = inject(NgbActiveModal);


    destroy$: Subject<boolean> = new Subject<boolean>();

    closeModal(isContinue:boolean){
      this.activeModal.close(isContinue);
    }
}